import { useEffect, useState } from "react";

const ANCHORS = [
  { id: "why-they-stay", label: "Pourquoi rester" },
  { id: "process-steps", label: "Notre process" },
  { id: "channel-manager", label: "Diffusion" },
  { id: "operations-numbers", label: "Nos chiffres" },
  { id: "results-teaser", label: "Cas clients" },
  { id: "booster-banner", label: "Booster vos revenus" },
  { id: "whatsapp-gallery", label: "Avis voyageurs" },
  { id: "engagement-testimonials", label: "Avis propriétaires" },
  { id: "brochure-cta", label: "Recevoir la brochure" },
];

const EngagementsAnchorNav = () => {
  const [active, setActive] = useState("");
  const [pinned, setPinned] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setPinned(window.scrollY > 600);
      let current = "";
      for (const a of ANCHORS) {
        const el = document.getElementById(a.id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 140) current = a.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <div
      data-testid="engagements-anchor-nav"
      className={`sticky top-[72px] z-40 bg-cream/85 backdrop-blur-md border-y border-gold/20 transition-all duration-500 ${
        pinned ? "shadow-soft" : ""
      }`}
    >
      <div className="container-tm">
        <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
          <span className="text-[10px] uppercase tracking-[0.22em] font-semibold text-ink/40 pr-3 hidden md:inline whitespace-nowrap">
            Sommaire ⎯⎯
          </span>
          {ANCHORS.map((a, i) => {
            const isActive = active === a.id;
            return (
              <button
                key={a.id}
                type="button"
                onClick={() => scrollTo(a.id)}
                data-testid={`anchor-${a.id}`}
                className={`whitespace-nowrap shrink-0 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[12px] font-medium transition-all duration-300 ${
                  isActive
                    ? "bg-ink text-cream"
                    : "text-ink/65 hover:text-ink hover:bg-gold/10"
                }`}
              >
                <span className="font-serif italic text-gold/70 mr-0.5">
                  0{i + 1}
                </span>
                {a.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EngagementsAnchorNav;
